import { Directive, effect, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[disabledControl]',
})
export class DisabledControlDirective {
  private ngControl = inject(NgControl, { self: true });

  readonly isDisabled = input<boolean>(undefined, { alias: "disabledControl" });

  constructor() {
    effect(() => {
      const isDisabled = this.isDisabled();
      const action = isDisabled ? 'disable' : 'enable';
      this.ngControl.control[action]();
    });
  }
}